import { ControlItem } from "../control-items";

export const TransactionTypesEnum: ControlItem[] = [
  { label: "Payment_Applied", value: "1" },
  { label: "Order_Fully_Placed", value: "2" }
]

export function getTransactionTypes(productTypeId?: string): string {
  if (!productTypeId) return "";
  return TransactionTypesEnum.find(c => c.value == productTypeId)?.label;
}

export const ProductTypesEnum: ControlItem[] = [
    { label: "DomesticTopUp", value: "1" },
    { label: "InternationalTopUp", value: "2" },
    { label: "PridExpress", value: "3" },
    { label: "Health", value: "4" },
]
export const OrderStatusEnum: ControlItem[] = [
  { label: "Processing", value: "1" },
  { label: "Out for Delivery", value: "2" },
  { label: "Delivered", value: "3" },
  { label: "Pending", value: "4" },
  { label: "Canceled", value: "5" },
  { label: "Success", value: "6" },
];

export function getProductTypeName(transactionTypeId?: string): string {
    if (!transactionTypeId) return "";
    return ProductTypesEnum.find(c => c.value == transactionTypeId)?.label;
  }

  export const UserRoleEnum: ControlItem[] = [
    { label: "Admin", value: "1" },
    { label: "Distributor", value: "2" },
    { label: "Employee", value: "3" },
    { label: "Retailer", value: "4" },
    { label: "Customer", value: "5" },
]

export function getUserRoleName(UserRoleId?: string): string {
    if (!UserRoleId) return "";
    return UserRoleEnum.find(c => c.value == UserRoleId)?.label;
  }

  export const RetailerTypeEnum: ControlItem[] = [
    { label: "MoneyTransferAgent", value: "1" },
    { label: "GroceryFoodMarket", value: "2" },
    { label: "WirelessStore", value: "3" },
    { label: "CommunityLeader", value: "4" },
    { label: "Individual", value: "4" },
    { label: "GeneralStore", value: "4" },
]

export function getRetailerTypeName(RetailerTypeId?: string): string {
    if (!RetailerTypeId) return "";
    return RetailerTypeEnum.find(c => c.value == RetailerTypeId)?.label;
  }

  export const RetailerPlanTypeEnum: ControlItem[] = [
    { label: "Prepaid", value: "1" },
    { label: "Postpaid", value: "2" }
]

export function getRetailerPlanTypeName(RetailerPlanTypeId?: string): string {
    if (!RetailerPlanTypeId) return "";
    return RetailerPlanTypeEnum.find(c => c.value == RetailerPlanTypeId)?.label;
  }